const Fact = ({ id, label, value, missing }) => (
  <div data-testid={`job-fact-${id}`} className="border hairline bg-white px-3 py-2.5 min-w-0">
    <p className="font-mono-label text-[10px] !tracking-normal text-[#71747B]">{label}</p>
    <p data-testid={`job-fact-${id}-value`} className={`mt-1 text-sm leading-snug break-words ${value ? "text-[#0F141B] font-semibold" : "text-[#8A94A2] italic"}`}>{value || missing}</p>
  </div>
);

export const JobFacts = ({ job }) => (
  <div data-testid="job-facts" className="grid grid-cols-2 sm:grid-cols-3 gap-2">
    <Fact id="pay" label="Pay" value={job.pay} missing="Not disclosed by employer" />
    <Fact id="level" label="Experience level" value={job.level !== "Not specified" ? job.level : null} missing="Not stated" />
    <Fact id="experience" label="Years of experience" value={job.years_experience !== null && job.years_experience !== undefined ? `${job.years_experience}+ years` : null} missing="Not stated" />
    <Fact id="workplace" label="Workplace" value={job.workplace !== "Not specified" ? job.workplace : null} missing="Not stated" />
    <Fact id="employment" label="Employment type" value={job.employment_type} missing="Not stated" />
    <Fact id="education" label="Education" value={job.education} missing="Not stated" />
    <Fact id="shift" label="Shift pattern" value={job.shift} missing="No shift requirement mentioned" />
    <Fact id="travel" label="Travel" value={job.travel} missing="No travel mentioned" />
    <Fact id="department" label="Team" value={job.department} missing="Not stated" />
  </div>
);
